module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotGroupDetails) ? _c('b-modal', {
    ref: "missionSlotCreateModal",
    attrs: {
      "id": "missionSlotCreateModal",
      "size": "lg",
      "title": _vm.slotCreateTitle,
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.createMissionSlot($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.title'),
      "state": _vm.missionSlotCreateTitleState,
      "feedback": _vm.missionSlotCreateTitleFeedback,
      "description": _vm.$t('mission.slot.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotCreateData.title),
      callback: function($$v) {
        _vm.missionSlotCreateData.title = $$v
      },
      expression: "missionSlotCreateData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionSlotCreateData.description),
      callback: function($$v) {
        _vm.missionSlotCreateData.description = $$v
      },
      expression: "missionSlotCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.difficulty'),
      "state": "success",
      "description": _vm.$t('mission.slot.difficulty.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionSlotCreateDifficultyOptions,
      "required": ""
    },
    model: {
      value: (_vm.missionSlotCreateData.difficulty),
      callback: function($$v) {
        _vm.missionSlotCreateData.difficulty = $$v
      },
      expression: "missionSlotCreateData.difficulty"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.restricted.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateData.restricted),
      callback: function($$v) {
        _vm.missionSlotCreateData.restricted = $$v
      },
      expression: "missionSlotCreateData.restricted"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.reserve.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.reserve.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateData.reserve),
      callback: function($$v) {
        _vm.missionSlotCreateData.reserve = $$v
      },
      expression: "missionSlotCreateData.reserve"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.blocked.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.blocked.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateData.blocked),
      callback: function($$v) {
        _vm.missionSlotCreateData.blocked = $$v
      },
      expression: "missionSlotCreateData.blocked"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.autoAssignable.slot'),
      "state": "success",
      "description": _vm.$t('mission.slot.autoAssignable.description'),
      "feedback": _vm.missionSlotCreateAutoAssignableFeedback
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.areMissionSlotAutoAssignable
    },
    model: {
      value: (_vm.missionSlotCreateData.autoAssignable),
      callback: function($$v) {
        _vm.missionSlotCreateData.autoAssignable = $$v
      },
      expression: "missionSlotCreateData.autoAssignable"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.missionSlotCreateData.restricted) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.restricted.selection'),
      "state": _vm.missionSlotCreateRestrictedCommunityState,
      "description": _vm.$t('mission.slot.restricted.selection.description')
    }
  }, [_c('typeahead', {
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.restrictedSlotCommunitySelected
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.detailedDescription.optional'),
      "state": "success",
      "description": _vm.$t('mission.slot.detailedDescription.description')
    }
  }, [_c('quill-editor', {
    ref: "missionSlotCreateDetailedDescriptionEditor",
    attrs: {
      "options": _vm.missionSlotCreateDetailedDescriptionEditorOptions
    },
    model: {
      value: (_vm.missionSlotCreateData.detailedDescription),
      callback: function($$v) {
        _vm.missionSlotCreateData.detailedDescription = $$v
      },
      expression: "missionSlotCreateData.detailedDescription"
    }
  }), _vm._v(" "), _c('editor-explanation')], 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "text-success",
    staticStyle: {
      "font-size": "1rem",
      "font-weight": "400",
      "line-height": "1.5"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.aow),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.aow = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.aow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.apex),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.apex = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.apex"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.contact),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.contact = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.csla),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.csla = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.csla"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.gm),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.gm = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.gm"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.helicopters),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.helicopters = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.helicopters"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.jets),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.jets = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.jets"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.karts),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.karts = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.karts"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.lawsofwar),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.lawsofwar = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.lawsofwar"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.marksmen),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.marksmen = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.marksmen"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.tacops),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.tacops = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.tacops"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.tanks),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.tanks = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.tanks"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionSlotCreateRequiredDLCs.vn),
      callback: function($$v) {
        _vm.missionSlotCreateRequiredDLCs.vn = $$v
      },
      expression: "missionSlotCreateRequiredDLCs.vn"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slot.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slot.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotCreateData.insertAfter = $$v
      },
      expression: "missionSlotCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionSlot
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a6b428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionSlotCreateModal.vue
// module id = 520
// module chunks = 0